"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Policy_1 = require("./Policy");
class MatureCEECountryPolicy extends Policy_1.Policy {
    constructor() {
        super(...arguments);
        this.countries = [
            42, 40, 2, 38, 7, 8, 46, 12, 230, 16, 17, 18, 37, 39, 20, 33, 23, 41, 31
        ];
    }
    meets(criteria) {
        return this.countries.includes(criteria.countryId);
    }
}
exports.default = new MatureCEECountryPolicy();
